export default "<p>trazim works!</p>\n\n<div> {{ subscribedParam }}</div>\n\n<br>\n\n<div>{{ snapshotParam }}</div>\n"